import PreviewImage from '@/components/main/PreviewImage'
import PreviewTextContent from '@/components/main/PreviewTextContent'
import { IPreviewItem } from '@/types/main'

const SECTION_CLASSES = {
  base: 'flex items-center mx-auto max-w-full mb-[135px]',
  offset: 'mb-[135px]',
  imageOffset: {
    left: 'max-w-full',
    right: ' max-w-full'
  }
}

const PREVIEW_IMAGE_SECTIONS = ['MAIN', 'TRADE', 'FEED', 'SHOP'] as const

interface IPreviewItemProps {
  item: IPreviewItem
  index: number
}

const PreviewItem: React.FC<IPreviewItemProps> = ({ item, index }) => {
  const isEven = index % 2 === 0
  const sectionClass = `${SECTION_CLASSES.base} ${
    isEven ? 'ml-[-60px]' : 'mr-[-60px]'
  }`

  const textContentProps = {
    title: item.title,
    heading: item.heading,
    description: item.description,
    reverse: !isEven
  }

  const ImageWrapper = () => (
    <div
      className={
        isEven
          ? SECTION_CLASSES.imageOffset.left
          : SECTION_CLASSES.imageOffset.right
      }
    >
      <PreviewImage section={PREVIEW_IMAGE_SECTIONS[index]} />
    </div>
  )

  return (
    <section key={index} className={sectionClass}>
      {isEven ? (
        <>
          <ImageWrapper />
          <PreviewTextContent {...textContentProps} />
        </>
      ) : (
        <>
          <PreviewTextContent {...textContentProps} />
          <ImageWrapper />
        </>
      )}
    </section>
  )
}

export default PreviewItem
